var o = Object.defineProperty;
var d = (r, e, t) => e in r ? o(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t;
var u = (r, e, t) => d(r, typeof e != "symbol" ? e + "" : e, t);
const a = "default";
function h(r) {
  return typeof r == "object" ? r : { subscribed: r };
}
class f {
  constructor(e) {
    u(this, "instance");
    this.instance = e;
  }
  /**
   * @deprecated Use `user.getAllPreferences()` instead
   */
  async getAll() {
    this.instance.failIfNotAuthenticated();
    const e = await this.instance.client().makeRequest({
      method: "GET",
      url: `/v1/users/${this.instance.userId}/preferences`
    });
    return this.handleResponse(e);
  }
  /**
   * @deprecated Use `user.getPreferences()` instead
   */
  async get(e = {}) {
    this.instance.failIfNotAuthenticated();
    const t = e.preferenceSet || a, s = await this.instance.client().makeRequest({
      method: "GET",
      url: `/v1/users/${this.instance.userId}/preferences/${t}`
    });
    return this.handleResponse(s);
  }
  /**
   * @deprecated Use `user.setPreferences(preferenceSet, options)` instead
   */
  async set(e, t = {}) {
    this.instance.failIfNotAuthenticated();
    const s = t.preferenceSet || a, n = await this.instance.client().makeRequest({
      method: "PUT",
      url: `/v1/users/${this.instance.userId}/preferences/${s}`,
      data: e
    });
    return this.handleResponse(n);
  }
  /**
   * @deprecated Use `user.setPreferences(preferenceSet, options)` instead
   */
  async setChannelTypes(e, t = {}) {
    this.instance.failIfNotAuthenticated();
    const s = t.preferenceSet || a, n = await this.instance.client().makeRequest({
      method: "PUT",
      url: `/v1/users/${this.instance.userId}/preferences/${s}/channel_types`,
      data: e
    });
    return this.handleResponse(n);
  }
  /**
   * @deprecated Use `user.setPreferences(preferenceSet, options)` instead
   */
  async setChannelType(e, t, s = {}) {
    this.instance.failIfNotAuthenticated();
    const n = s.preferenceSet || a, c = await this.instance.client().makeRequest({
      method: "PUT",
      url: `/v1/users/${this.instance.userId}/preferences/${n}/channel_types/${e}`,
      data: { subscribed: t }
    });
    return this.handleResponse(c);
  }
  /**
   * @deprecated Use `user.setPreferences(preferenceSet, options)` instead
   */
  async setWorkflows(e, t = {}) {
    this.instance.failIfNotAuthenticated();
    const s = t.preferenceSet || a, n = await this.instance.client().makeRequest({
      method: "PUT",
      url: `/v1/users/${this.instance.userId}/preferences/${s}/workflows`,
      data: e
    });
    return this.handleResponse(n);
  }
  /**
   * @deprecated Use `user.setPreferences(preferenceSet, options)` instead
   */
  async setWorkflow(e, t, s = {}) {
    this.instance.failIfNotAuthenticated();
    const n = s.preferenceSet || a, c = h(t), i = await this.instance.client().makeRequest({
      method: "PUT",
      url: `/v1/users/${this.instance.userId}/preferences/${n}/workflows/${e}`,
      data: c
    });
    return this.handleResponse(i);
  }
  /**
   * @deprecated Use `user.setPreferences(preferenceSet, options)` instead
   */
  async setCategories(e, t = {}) {
    this.instance.failIfNotAuthenticated();
    const s = t.preferenceSet || a, n = await this.instance.client().makeRequest({
      method: "PUT",
      url: `/v1/users/${this.instance.userId}/preferences/${s}/categories`,
      data: e
    });
    return this.handleResponse(n);
  }
  /**
   * @deprecated Use `user.setPreferences(preferenceSet, options)` instead
   */
  async setCategory(e, t, s = {}) {
    this.instance.failIfNotAuthenticated();
    const n = s.preferenceSet || a, c = h(t), i = await this.instance.client().makeRequest({
      method: "PUT",
      url: `/v1/users/${this.instance.userId}/preferences/${n}/categories/${e}`,
      data: c
    });
    return this.handleResponse(i);
  }
  handleResponse(e) {
    if (e.statusCode === "error")
      throw new Error(e.error || e.body);
    return e.body;
  }
}
export {
  f as default
};
//# sourceMappingURL=index.mjs.map
